export enum HttpMethod {
  Get = "GET",
  Put = "PUT",
  Patch = "PATCH",
  Post = "POST",
  Delete = "DELETE",
}
